export default "__VITE_ASSET__DiqeaRLV__"